module.exports = __webpack_public_path__ + "v294910/img/icon-lone.64fa6a63.png";